// extracted by mini-css-extract-plugin
module.exports = {"hits-wrap":"ModalArticleHits_hits-wrap__smeeQ","hits-header":"ModalArticleHits_hits-header__yEmkV","hits-items":"ModalArticleHits_hits-items__QRf5Z"};